import { Box, Button, ButtonProps } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './Button.scss';

interface AppButtonProps extends ButtonProps {
  isLink?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({
  title,
  type,
  color,
  isLink = false,
  sx,
  disabled,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <Box className="AppButton">
      <Button
        variant={isLink ? 'text' : 'contained'}
        color={color}
        disabled={disabled}
        className="AppButton__content"
        onClick={onClick}
        type={type}
        sx={sx}
      >
        {t(title!)}
      </Button>
    </Box>
  );
};

export default AppButton;
